/** API case-request category: Attorney General */
export const ATTORNEY_GENERAL_CATEGORY_ID = '391267f3-8e19-4f78-9a82-1eb0ca5041a9';
export const ATTORNEY_GENERAL_CATEGORY_CODE = 'ATTORNEY_GENERAL';
export const FILE_CATEGORY_ATTORNEY_GENERAL = 'Attorney General';

/** API case-request category: AGD - Internal (same wizard as Attorney General) */
export const AGD_INTERNAL_CATEGORY_ID = '5123ae57-bbd3-42e0-94e5-a609bf655421';
export const AGD_INTERNAL_CATEGORY_CODE = 'AGD_INTERNAL';
export const FILE_CATEGORY_AGD_INTERNAL = 'AGD - Internal';

export function isAttorneyGeneralCategory(item: {
  id?: string;
  name?: string;
  code?: string;
}): boolean {
  const id = (item.id ?? '').trim();
  const code = (item.code ?? '').trim().toUpperCase();
  const name = (item.name ?? '').trim().toLowerCase();
  if (id === ATTORNEY_GENERAL_CATEGORY_ID || id === AGD_INTERNAL_CATEGORY_ID) return true;
  if (code === ATTORNEY_GENERAL_CATEGORY_CODE || code === AGD_INTERNAL_CATEGORY_CODE) return true;
  if (code.includes('ATTORNEY_GENERAL') || code.includes('AGD_INTERNAL')) return true;
  if (name === 'attorney general' || name.includes('agd - internal') || name.includes('agd internal')) {
    return true;
  }
  return false;
}

export const ATTORNEY_GENERAL_WIZARD_STEPS = [
  { n: 1, lbl: 'Case Overview' },
  { n: 2, lbl: 'Party Details' },
  { n: 3, lbl: 'Incident Details' },
  { n: 4, lbl: 'Victim Details' },
  { n: 5, lbl: 'Offence & Accused Details', lblLines: ['Offence & Accused', 'Details'] as const },
  {
    n: 6,
    lbl: 'Accused Person Details - Extradition & MLA',
    lblLines: ['Accused Person Details', 'Extradition & MLA'] as const,
  },
  { n: 7, lbl: 'Legal & Extradition', lblLines: ['Legal &', 'Extradition'] as const },
  { n: 8, lbl: 'Petitioner Details', lblLines: ['Petitioner', 'Details'] as const },
  { n: 9, lbl: 'Right to Information', lblLines: ['Right to', 'Information'] as const },
  { n: 10, lbl: 'Timeline' },
  { n: 11, lbl: 'Submission' },
  { n: 12, lbl: 'Upload Documents', lblLines: ['Upload', 'Documents'] as const },
] as const;

export type AttorneyGeneralWizardStep = (typeof ATTORNEY_GENERAL_WIZARD_STEPS)[number]['n'];

/** CMS Data Capture — court types when action is instituted */
export const ATTORNEY_GENERAL_COURT_TYPES = [
  { id: 'PHC', name: 'Provincial High Court (PHC)', code: 'PHC' },
  { id: 'HC', name: 'High Court (HC)', code: 'HC' },
  { id: 'DC', name: 'District Court (DC)', code: 'DC' },
  { id: 'CHC', name: 'Commercial High Court (CHC)', code: 'CHC' },
  { id: 'LT', name: 'Labour Tribunal (LT)', code: 'LT' },
  { id: 'MC', name: "Magistrates' Court (MC)", code: 'MC' },
  { id: 'SCC', name: 'Small Claims Court (SCC)', code: 'SCC' },
  { id: 'ARB', name: 'Arbitration (ARB)', code: 'ARB' },
  { id: 'DAB', name: 'Dispute Adjudication Board (DAB)', code: 'DAB' },
  { id: 'USAB', name: 'University Services Appeals Board (USAB)', code: 'USAB' },
  { id: 'AAT', name: 'Administrative Appeals Tribunal (AAT)', code: 'AAT' },
  { id: 'OT', name: 'Other (OT)', code: 'OT' },
] as const;

export function isOtherCourtType(codeOrId: string, name?: string): boolean {
  const c = codeOrId.trim().toUpperCase();
  if (c === 'OT' || c === 'OTHER') return true;
  return (name ?? '').trim().toLowerCase() === 'other';
}

export function isBriberySubCategory(subFileCategoryName: string): boolean {
  const n = subFileCategoryName.trim().toLowerCase();
  return n.includes('bribery') && n.includes('corruption');
}
